<template>
  <b-card class="shadow-sm" header-class="pl-2 card-header-inline">
    <template v-slot:header>
      <BackButton
        class="mr-1"
        :redirect-to="backButtonRedirect"
      />
      <header class="pt-2">
        Import Nilai Mahasiswa
      </header>
    </template>

    <b-alert
      variant="danger"
      :show="true"
      fade
    >
      <h4 class="alert-heading">
        Perhatian!
      </h4>
      <hr class="my-2">
      <p class="mt-0">
        {{ message.templateChangedByUser }}
      </p>
    </b-alert>

    <DetailMatakuliah />

    <Alert
      alert-type="error"
      :icon="iconError"
      message="Upload nilai mahasiswa sesuai periode semester aktif."
      v-if="activeSemesterButton === false"
    />

    <Alert
      alert-type="error"
      :icon="iconError"
      message="Tipe Template nilai tidak diketahui!"
      v-if="templateType === null"
    />

    <Alert
      alert-type="error"
      :icon="iconError"
      :message="uploadFailedMessage"
      v-if="uploadFailedMessage !== null"
    />

    <b-row v-if="templateType !== null">
      <b-col lg="6" md="6" sm="12">
        <b-form
          @submit.prevent="submitData"
        >
          <b-form-group
            :label="templateType !== 'AllKomponen' ? 'Komponen Penilaian' : 'Seluruh Komponen Penilaian'"
          >
            <b-form-select
              v-if="templateType === 'PerKomponen'"
              v-model="assessComponentId"
              :options="assessmentComponent"
              value-field="komPenId"
              text-field="komPenNama"
              required
            >
              <slot name="first">
                <option :value="null">
                  Pilih Komponen Penilaian
                </option>
              </slot>
            </b-form-select>
          </b-form-group>
          <b-form-group
            description="Upload nilai mahasiswa dengan ekstensi file .xlsx"
          >
            <b-form-file
              placeholder=".xlsx"
              :value="templateFile"
              @input="setTemplateFile"
              accept=".xlsx"
              browse-text="Pilih Template Nilai"
              required
            />
          </b-form-group>
          <b-button
            type="submit"
            variant="primary"
            :disabled="uploadButtonState"
          >
            Upload
          </b-button>
        </b-form>
      </b-col>
      <b-col lg="6" md="6" sm="12">
        <b-skeleton-wrapper :loading="loadingUpload">
          <template #loading>
            <b-skeleton width="50%" height="10%"></b-skeleton>

            <dl class="row mt-3">
              <dt class="col-6">
                <b-skeleton></b-skeleton>
              </dt>
              <dd class="col-6">
                <b-skeleton width="70%"></b-skeleton>
              </dd>
              <dt class="col-6">
                <b-skeleton></b-skeleton>
              </dt>
              <dd class="col-6">
                <b-skeleton width="70%"></b-skeleton>
              </dd>
              <dt class="col-6">
                <b-skeleton></b-skeleton>
              </dt>
              <dd class="col-6">
                <b-skeleton width="70%"></b-skeleton>
              </dd>
              <dt class="col-6">
                <b-skeleton></b-skeleton>
              </dt>
              <dd class="col-6">
                <b-skeleton width="70%"></b-skeleton>
              </dd>
              <dt class="col-6">
                <b-skeleton></b-skeleton>
              </dt>
              <dd class="col-6">
                <b-skeleton width="70%"></b-skeleton>
              </dd>
            </dl>
          </template>

          <div v-if="uploadStatusExists">
            <p class="lead">Upload Status</p>

            <dl class="row">
              <dt class="col-6">
                Success:
              </dt>
              <dd class="col-6">
                {{ uploadStatus.success.length }}
              </dd>
              <dt class="col-6">
                Updated:
              </dt>
              <dd class="col-6">
                {{ uploadStatus.updated.length }}
              </dd>
              <dt class="col-6">
                Unchanged:
              </dt>
              <dd class="col-6">
                {{ uploadStatus.unchanged.length }}
              </dd>
              <dt class="col-6">
                Failed:
              </dt>
              <dd class="col-6">
                {{ uploadStatus.failed.length }}
              </dd>
              <dt class="col-6">
                Total Rows:
              </dt>
              <dd class="col-6">
                {{ uploadStatus.total }}
              </dd>
            </dl>
          </div>
        </b-skeleton-wrapper>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
import { isNil, isEmpty, equalSemester } from '@/helpers'
import { ModalMessageMixin, BackButton, Alert } from '@/components'
// module
import DetailMatakuliah from '@/modules/matakuliah/Detail'

export default {
  name: 'ImportNilaiMahasiswa',
  mixins: [ModalMessageMixin],
  components: {
    BackButton,
    DetailMatakuliah,
    Alert
  },
  computed: {
    ...mapGetters({
      userDetail: 'users/getUserDetail'
    }),
    ...mapState('faculty', {
      activeSemester: 'activeSemesterId'
    }),
    ...mapState('assessment', {
      templateType: 'templateType',
      templateFile: 'templateFile'
    }),
    ...mapState('komponenPenilaian', {
      currentSemester: 'semesterId'
    }),
    uploadStatusExists () {
      return !isEmpty(this.uploadStatus)
    },
    uploadButtonState () {
      // disable button 'true'
      if (isNil(this.templateFile)) {
        return true
      } else if (this.templateType === 'PerKomponen' && isNil(this.assessComponentId)) {
        return true
      } else {
        return this.disableUploadButton
      }
    }
  },
  data () {
    return {
      disableUploadButton: false,
      activeSemesterButton: false,
      assessmentComponent: [],
      assessComponentId: null,
      uploadStatus: {},
      uploadFailedMessage: null,
      backButtonRedirect: {
        name: 'dosen.mahasiswa-nilai',
        params: this.$route.params
      },
      loadingUpload: false,
      iconError: 'shield-exclamation',
      message: {
        templateChangedByUser: 'Jangan pernah mengubah konten template yang diunduh baik judul maupun urutan kolom komponen penilaian.',
        templateError: 'Terjadi kendala dalam membaca Template, silahkan download template ulang!'
      }
    }
  },
  beforeMount () {
    if (this.templateType !== null) {
      this.setTemplateFile(null)
      this.getAllKomponenNilai(this.$route.params.kelasId)
        .then(({ data }) => {
          this.assessmentComponent = data
          this.getInfoMatakuliah(this.$route.params.kelasId)
          this.activeSemesterButton = equalSemester(this.activeSemester, this.currentSemester)
        }).then(() => {
          this.$bvModal.msgBoxOk(this.message.templateChangedByUser, {
            size: 'lg',
            title: 'Peringatan',
            okVariant: 'warning',
            centered: true
          })
        })
    }
  },
  beforeDestroy () {
    this.setTemplateType(null)
  },
  methods: {
    ...mapMutations('assessment', ['setTemplateType', 'setTemplateFile']),
    ...mapActions('assessment', ['sentStudentGrade']),
    ...mapActions('komponenPenilaian', ['getInfoMatakuliah', 'getAllKomponenNilai']),
    async submitData () {
      // Disable button
      this.disableUploadButton = true
      this.loadingUpload = true

      // Process sheet
      try {
        const { data } = await this.sentStudentGrade({
          assessmentComponent: this.assessmentComponent,
          kelasId: this.$route.params.kelasId,
          assessComponentId: this.assessComponentId
        })
        this.uploadStatus = data
        this.disableUploadButton = false
        this.loadingUpload = false
        this.assessComponentId = null
        this.setTemplateFile(null)
      } catch (err) {
        console.error(err)
        this.uploadFailedMessage = err.message
        this.assessComponentId = null
        this.setTemplateFile(null)
        this.disableUploadButton = false
        this.loadingUpload = false
      }
    }
  }
}
</script>

<style scoped>
.card-header-inline {
  display: inline-flex;
}
</style>
